import Logo from "../../../../../../packages/design-system/src/Logo";
import * as React from 'react';
export default {
  Logo,
  React
};